<template>
	<div class="full-width">
		<v-layout row wrap>
			<v-flex xs12 md6 lg4 v-for="(item,index) in userPosts" :key="index" class="px-3 my-2">
				<analytics-el :post="item" :isLive="true" :bypassPreFetch="true" :SM="true"></analytics-el>
			</v-flex>
		</v-layout>
		<v-layout v-if="fetchPostsLoading" class="my-5">
			<v-flex xs12 class="allCenteredChild">
				<v-progress-circular indeterminate :color="themeInputColor" :size="60"/>
			</v-flex>
		</v-layout>
		<v-layout class="my-5" v-else>
			<v-flex v-if="hasMorePosts" class="allCenteredChild">
				<v-btn
					outline
					:color="themeInputColor"
					:loading="fetchPostsLoading"
					@click="fetchRecentPosts('end')"
				>load more posts</v-btn>
			</v-flex>
			<v-flex v-else class="allCenteredChild">
				<v-btn large disabled>no more posts</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapState } from "vuex";

import AnalyticsEl from "./Analytics-el";
import { themeInputColor } from "@/utils";
import { FETCH_POSTS } from "@/store/action-types";

export default {
	name: "Posts",
	data() {
		return {
			themeInputColor,
			fetchPostsLoading: false
		};
	},
	components: {
		"analytics-el": AnalyticsEl
	},
	mounted() {
		this.fetchRecentPosts("start");
	},
	computed: {
		...mapState({
			userPosts: state => state.user.userPosts,
			// fetchPostsLoading: "fetchPostsLoading",
			userPostsLastEvalKey: state => state.user.userPostsLastEvalKey
		}),
		hasMorePosts() {
			return this.userPostsLastEvalKey ? true : false;
		}
	},
	methods: {
		fetchRecentPosts(dir) {
			if (!this.fetchPostsLoading) {
				this.fetchPostsLoading = true;
				this.$store
					.dispatch(FETCH_POSTS.dispatch, dir)
					.catch(() => {})
					.then(() => {
						this.fetchPostsLoading = false;
					});
			}
		}
	}
};
</script>
